module.exports = __webpack_public_path__ + "static/AzoSans-Regular-d10bda10fe673a124e2ea99751ee3ffe.eot";